<template>
  <ErrorBoundary module-name="TopHeaderContainer">
    <header
      id="top-header-container"
      ref="topHeaderContainer"
      class="top-header-container"
    >
      <TopHeader
        v-if="!searchActive"
        :is-authenticated="isAuthenticated"
        :user-avatar-src="userAvatarSrc"
        :do-authorization="doAuthorization"
        :user-integer-id="userIntegerId"
        :logout="logout"
        :primary-nav-menu-items="primaryNavMenuItems"
        :show-nav="showNav"
        @click-on-logo="onClickOnLogo"
        @click-on-search="onClickSearch"
      />
      <TopHeaderSearch
        v-else
        @click-on-close="closeSearch"
        @search="closeSearch"
      />
    </header>
  </ErrorBoundary>
</template>

<script lang="ts">
  import { getFullUrl } from '~/utils';
  import type { User } from '@devhacker/shared/features/user/types/user';

  import TopHeader from '~/components/TopHeader/TopHeader.vue';
  import TopHeaderSearch from '~/components/TopHeaderSearch/TopHeaderSearch.vue';
  import TopHeaderSearchActionsheet from '~/components/TopHeaderSearch/TopHeaderSearchActionsheet.vue';
  import { useMenusStore } from '~/store/menus';
  import { leavePrivateChannel } from '~/components/Pusher/websockets-functions';
  import { useIndexStore } from '~/store';
  import { usePusherStore } from '~/store/pusher';
  import ErrorBoundary from '@devhacker/shared/components/ErrorBoundary.vue';
  import { useModal } from '@devhacker/shared/plugins/modal/useModal';
  import { useAuthRedirect } from '@devhacker/shared/features/auth/utils/authRedirect';

  export default defineNuxtComponent({
    name: 'TopHeaderContainer',
    components: {
      TopHeader,
      TopHeaderSearch,
      ErrorBoundary,
    },

    data() {
      return {
        searchActive: false as boolean,
      };
    },
    setup() {
      return {
        indexStore: useIndexStore(),
        menusStore: useMenusStore(),
        pusherStore: usePusherStore(),
      };
    },
    computed: {
      primaryNavMenuItems(): Array<MenuItem> {
        return this.menusStore.menus?.projects?.items ?? [];
      },
      user(): User | null {
        return this.indexStore.user ?? null;
      },
      userIntegerId(): string | null {
        return this.user?.integer_id ?? null;
      },
      userAvatarSrc(): string {
        const { user } = this;

        if (user && Array.isArray(user.avatars)) {
          const smallAvatar = user.avatars.find((avatar) => avatar.size === 's');
          if (smallAvatar && smallAvatar.url) {
            return smallAvatar.url;
          }
        }
        return '';
      },
      isAuthenticated(): boolean {
        // const { user } = this.$store.state as IRootState;
        // return user !== null;

        return Boolean(this.user);
      },
    },
    methods: {
      doAuthorization(_location = 'колокольчик'): void {
        useAuthRedirect().login();
      },
      logout() {
        leavePrivateChannel();
        this.pusherStore.resetStore();
        this.indexStore.logout();
      },
      showNav() {
        this.indexStore.showNav();
      },
      onClickOnLogo(): void {
        this.$sendYandexMetrika({
          level1: 'Клик_Лого',
          level4: getFullUrl('/'),
        });
      },
      onClickSearch() {
        if (window.innerWidth < 768) {
          useModal().open(
            TopHeaderSearchActionsheet,
            {},
            {
              transition: 'modal-fade',
              align: 'top',
            },
          );
        } else {
          this.searchActive = true;
        }
      },
      closeSearch() {
        this.searchActive = false;

        if (window.innerWidth < 768) {
          useModal().close();
        }
      },
    },
  });
</script>

<style lang="scss" scoped>
  .top-header-container {
    height: 48px;
    position: sticky;
    top: 0;
    // z-index: 13;
    z-index: 999;
  }
</style>
